export const LEFT_SIDEBAR_THREADS_VIEW_SETTINGS_ACTIONS = {
  TOGGLE_FILTER_BY_STARRED: 'LEFT_SIDEBAR_THREADS_VIEW_SETTINGS_ACTIONS/TOGGLE_FILTER_BY_STARRED',
  TOGGLE_FILTER_BY_UNREAD: 'LEFT_SIDEBAR_THREADS_VIEW_SETTINGS_ACTIONS/TOGGLE_FILTER_BY_UNREAD',
  TOGGLE_FILTER_BY_FOLLOWED: 'LEFT_SIDEBAR_THREADS_VIEW_SETTINGS_ACTIONS/TOGGLE_FILTER_BY_FOLLOWED',
  TOGGLE_FILTER_BY_UNFOLLOWED: 'LEFT_SIDEBAR_THREADS_VIEW_SETTINGS_ACTIONS/TOGGLE_FILTER_BY_UNFOLLOWED',
  TOGGLE_FILTER_BY_VIEWED: 'LEFT_SIDEBAR_THREADS_VIEW_SETTINGS_ACTIONS/TOGGLE_FILTER_BY_VIEWED',
}
